import { getApiBaseUrl } from "@maeiz/core";

export function resolveSseUrl(path = "/tenant/sse"): string {
    const apiBase = getApiBaseUrl().replace(/\/$/, "");
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;

    if (normalizedPath.startsWith("/api/")) {
        const origin = apiBase.replace(/\/api\/v\d+\/?$/, "") || apiBase;
        return `${origin}${normalizedPath}`;
    }

    return `${apiBase}${normalizedPath}`;
}
